import {
  Edit,
  TabbedForm,
  FormTab,
  TextInput,
  NumberInput,
  SelectInput,
  required,
} from "react-admin";
import { ProviderStatusActions } from "./ProviderStatusActions";
import { ProviderConfigurations } from "./ProviderConfigurations";
import { ProviderBusinessRules } from "./ProviderBusinessRules";

export const ProviderEdit = () => (
  <Edit>
    <TabbedForm>
      <FormTab label="Basic Info">
        <TextInput source="name" validate={required()} />
        <TextInput source="code" disabled />
        <SelectInput
          source="type"
          choices={[
            { id: "hotel", name: "Hotel" },
            { id: "flight", name: "Flight" },
            { id: "car_rental", name: "Car Rental" },
            { id: "activity", name: "Activity" },
            { id: "package", name: "Package" },
          ]}
          validate={required()}
        />
        <TextInput source="description" multiline rows={4} />
        <NumberInput source="priority" />
      </FormTab>

      <FormTab label="Configurations">
        <ProviderConfigurations />
      </FormTab>

      <FormTab label="Business Rules">
        <ProviderBusinessRules />
      </FormTab>

      <FormTab label="Status">
        <ProviderStatusActions />
      </FormTab>
    </TabbedForm>
  </Edit>
);
